export const OfferActionTypes = {
  Edit: "edit",
  New: "new",
  View: "view"
};
